import {
  REGISTRATION_FLOWS,
  type RegistrationFlow,
} from '@repo/api-kit/queries/registration-states';
import type { ApiOrganization } from '@repo/api-kit/queries/register-organization';

const GERMAN_FREELANCER_COMPANY_CREATION_FLOWS: readonly RegistrationFlow[] = [
  REGISTRATION_FLOWS.DE_FULL_COMPANY_CREATION_FREELANCERS,
  REGISTRATION_FLOWS.DE_COMPANY_CREATION_SOLE_TRADER,
];

const KBIS_UNRELIABLE_LEGAL_COUNTRIES: readonly string[] = ['AT', 'BE', 'PT'];

export function shouldRenderGermanFreelancerCompanyCreationForm(
  registrationFlow: RegistrationFlow | null
): boolean {
  if (registrationFlow === null) return false;
  return GERMAN_FREELANCER_COMPANY_CREATION_FLOWS.includes(registrationFlow);
}

export function shouldHideBackButton(registrationFlow: RegistrationFlow | null): boolean {
  return registrationFlow === REGISTRATION_FLOWS.DE_FULL_COMPANY_CREATION_FREELANCERS;
}

export function shouldCollectKbisForEuStandard(
  organization: Pick<ApiOrganization, 'unreferenced' | 'underRegistration' | 'legalCountry'>
): boolean {
  if (organization.unreferenced) return true;
  return (
    !organization.underRegistration &&
    KBIS_UNRELIABLE_LEGAL_COUNTRIES.includes(organization.legalCountry)
  );
}
